import { render, staticRenderFns } from "./Busanmietung.vue?vue&type=template&id=18ae6872&scoped=true&"
import script from "./Busanmietung.vue?vue&type=script&lang=js&"
export * from "./Busanmietung.vue?vue&type=script&lang=js&"
import style0 from "./Busanmietung.vue?vue&type=style&index=0&id=18ae6872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae6872",
  null
  
)

export default component.exports